import * as Sentry from '@sentry/react';
export function initSentry(config) {
    const dsn = config?.dsn ?? import.meta.env.VITE_SENTRY_DSN ?? '';
    if (!dsn) {
        console.info('[sentry] Sentry disabled (no DSN configured)');
        return;
    }
    const env = import.meta.env;
    Sentry.init({
        dsn,
        environment: config?.environment ?? env.VITE_SENTRY_ENVIRONMENT ?? 'development',
        release: config?.release ?? (typeof __GIT_HASH__ !== 'undefined' ? __GIT_HASH__ : 'unknown'),
        integrations: [
            config?.browserTracingIntegration ?? Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: config?.tracesSampleRate ?? 0.1,
        replaysSessionSampleRate: config?.replaysSessionSampleRate ?? 0.1,
        replaysOnErrorSampleRate: config?.replaysOnErrorSampleRate ?? 1.0,
    });
}
//# sourceMappingURL=init.js.map